import React, { useContext } from "react";
import Button from "../form-components/button";
import "./confirm-delete-modal.styles.css";
import { ConfirmDeleteModalContext } from "../../contexts/confirm-delete-modal-context";
import { deletePrayerFromFirestoreDb } from "../../utils/firebase-utils";
import { PrayerIdContext } from "../../contexts/prayer-id-context";

const ConfirmDeleteModal = () => {
  const { setOpenConfirmDeleteModal } = useContext(ConfirmDeleteModalContext);
  const { prayerId } = useContext(PrayerIdContext);

  const handleCancelClick = () => {
    setOpenConfirmDeleteModal(false);
  };

  const handleDeletePrayerClick = async () => {
    await deletePrayerFromFirestoreDb(prayerId);
    setOpenConfirmDeleteModal(false);
  };

  return (
    <>
      <div className="delete-modal">
        <div className="delete-modal-content">
          <div className="delete-modal-heading">
            <h3>Are you sure you want to delete this prayer?</h3>
            <div className="delete-modal-buttons">
              <div className="delete-button">
                <Button
                  buttonType={"deepMoss"}
                  onClick={handleDeletePrayerClick}
                >
                  Yes, delete prayer
                </Button>
              </div>
              <div className="cancel-button">
                <Button buttonType={"orange"} onClick={handleCancelClick}>
                  CANCEL
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDeleteModal;
